import { createBackgroundLoaderContext } from "contexts";
import { HandshakeCareer } from "models";

export const HandshakeCareersContext = createBackgroundLoaderContext<HandshakeCareer>();
